import { createQuery } from '@tanstack/solid-query'
import { getActivityId } from '~/config'
import type { ChallengeProgressRow } from '~/lib/derive-day-cards'
import { api } from '~/services/api'
import { userInfoSource } from '~/store/user-info'

type ProgressesResponse = {
  challenge_progresses: ChallengeProgressRow[]
}

export const progressesQueryKey = ['progresses'] as const

export const useProgresses = () => {
  return createQuery(() => ({
    queryKey: progressesQueryKey,
    queryFn: async () => {
      const userInfo = await userInfoSource.getReady()
      const response = await api.service
        .get(
          `challenge/users/${userInfo.user_id}/progresses/activity/${getActivityId(userInfo)}`,
          {
            searchParams: {
              include_subscription_progress: 'true',
            },
          },
        )
        .json<ProgressesResponse>()
      return response.challenge_progresses
    },
  }))
}
